<script lang="ts" setup>
export interface ImageGridProps {
    columnCount?: string | number
    columnGap?: string
}

const props = withDefaults(defineProps<ImageGridProps>(), {
    columnCount: 2,
    columnGap: '3rem',
})
</script>

<template>
  <div
    class="image-grid"
    :style="`--image-grid-column-count: ${props.columnCount}; --image-grid-column-gap: ${props.columnGap};`"
  >
    <slot />
  </div>
</template>

<style lang="scss" scoped>
@import './ImageGrid.scss';
</style>
